import { createSlice } from "@reduxjs/toolkit";

// Load from localStorage (if available)
const loadState = () => {
  try {
    const saved = localStorage.getItem("headerContent");
    return saved ? JSON.parse(saved) : {};
  } catch (err) {
    console.error("Error loading headerContent from localStorage:", err);
    return {};
  }
};

// Save to localStorage
const saveState = (state) => {
  try {
    localStorage.setItem("headerContent", JSON.stringify(state));
  } catch (err) {
    console.error("Error saving headerContent to localStorage:", err);
  }
};

const headerSlice = createSlice({
  name: "headerContent",
  initialState: loadState(), // use persisted state if available
  reducers: {
    addField: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
      saveState(state);
    },
    updateField: (state, action) => {
      const { key, value } = action.payload;
      if (state[key] !== undefined) {
        state[key] = value;
        saveState(state);
      }
    },
    removeField: (state, action) => {
      const key = action.payload;
      if (state[key] !== undefined) {
        delete state[key];
        saveState(state);
      }
    },
    resetFields: () => {
      console.log("reset call");
      saveState({});
      return {}; // reset to empty JSON
    },
    setAllFields: (state, action) => {
      saveState(action.payload);
      return action.payload; // replace whole JSON
    },
  },
});

export const { addField, updateField, removeField, resetFields, setAllFields } =
  headerSlice.actions;

export default headerSlice.reducer;
